import React from 'react';
import Timer from '../feature/timer/timer';

const TimerPage: React.FC = () => {
    return (
        <Timer />
    );
};

export default TimerPage;